import {
  BulletedList,
  NumberedList,
} from '@twistopayments/design-system/components/molecules/list'

import type { RichTextBlock } from '../rich-text.d'
import { useRichText } from '../rich-text.hook'

type Props = {
  content: RichTextBlock['children']
  className?: string
  format: RichTextBlock['format']
  size?: 'small' | 'medium'
}

export const List = ({
  content,
  className,
  format = 'unordered',
  size = 'medium',
}: Props) => {
  const { renderChildren } = useRichText()
  const Component = format === 'unordered' ? BulletedList : NumberedList

  return (
    <Component className={className} variant={size}>
      {renderChildren(content, { format })}
    </Component>
  )
}
